import React from 'react'
import { InlineAlert } from '@mobi/betslip/Components/Common/InlineAlert'
import { Card } from '@mobi/component-library/Base/Card'
import { BetInfo } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/BetInfo'
import { Details } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/Details/Details'
import { Investment } from '@core/Areas/Account/Pages/Activity/Components/Ticket/Components/Investment'
import {
  getTicketLayoutType,
  getTicketStatus,
} from '@core/Areas/Account/Pages/Activity/Components/Ticket/helpers'
import { TicketDisplayContext } from '@core/Areas/Account/Pages/Activity/context'
import type { TicketStatus } from '@core/Areas/Account/Pages/Activity/types'
import type { TicketShare as TicketShareType } from '@core/Areas/ShareBet/types'

export const TicketShare: React.FC<{ share: TicketShareType['share']; isCostShared: boolean }> = ({
  share: { ticket, activeTab },
  isCostShared,
}) => {
  const ticketTypeLayout = getTicketLayoutType(ticket)

  const ticketStatus = getTicketStatus(ticket, activeTab)
  const ticketStatusProps = getTicketStatusProps(ticketStatus)

  return (
    <Card
      topComponent={
        ticketStatusProps ? (
          <InlineAlert
            type={ticketStatusProps.type}
            text={ticketStatusProps.text}
            hasIcon={false}
            isCenterAlign
          />
        ) : null
      }
    >
      <TicketDisplayContext.Provider
        value={{
          type: 'share',
          data: { shouldHideCost: !isCostShared, display: 'external-share' },
        }}
      >
        <BetInfo ticket={ticket} status={ticketStatus} ticketLayoutType={ticketTypeLayout} />

        <Details ticket={ticket} />

        {isCostShared && <Investment status={ticketStatus} ticket={ticket} />}
      </TicketDisplayContext.Provider>
    </Card>
  )
}

// =============
// Local Helpers
// =============

function getTicketStatusProps(
  status: TicketStatus
): Pick<React.ComponentProps<typeof InlineAlert>, 'text' | 'type'> | null {
  if (status === 'Pending') {
    return { text: 'PENDING', type: 'warning' }
  }

  if (status === 'Won') {
    return { text: 'WINNER', type: 'success' }
  }

  if (status === 'NoPayout') {
    return { text: 'NO PAYOUT', type: 'neutral' }
  }

  if (!status) return null

  return { text: status, type: 'neutral' }
}
